import { Box, HStack, Switch, Text, VStack } from '@chakra-ui/react'
import { FiLock } from 'react-icons/fi'
import { useId } from 'react'

export interface FrameRow { label: string; locked: boolean; on: boolean; onToggle: () => void }
export interface FrameGroup { label?: string; rows: FrameRow[] }

/** [Spec §5.3] One door screen in miniature: the canvasser's own copy, a switch on each optional item. */
export function OutcomeFrame({ title, groups }: { title: string; groups: FrameGroup[] }) {
  const headingId = useId()
  return (
    <Box as="section" aria-labelledby={headingId} borderWidth="1px" borderColor="border" borderRadius="xl"
      bg="surface" p={4} w="100%" maxW={{ base: '100%', md: '320px' }}>
      <Text as="h3" id={headingId} fontWeight="bold" fontSize="md" mb={3}>{title}</Text>
      <VStack align="stretch" gap={3}>
        {groups.map((g, gi) => (
          <VStack key={gi} align="stretch" gap={1}>
            {g.label && <Text fontSize="xs" color="fg.muted" textTransform="uppercase" letterSpacing="wide">{g.label}</Text>}
            {g.rows.map(r => r.locked ? (
              <HStack key={r.label} justify="space-between" minH="44px" px={3} borderRadius="md"
                bg="bg.subtle" borderWidth="1px" borderColor="border">
                <Text color="fg">{r.label}</Text>
                <HStack gap={1} color="fg.muted" fontSize="sm"><FiLock aria-hidden /><Text>Always on</Text></HStack>
              </HStack>
            ) : (
              <Switch.Root key={r.label} checked={r.on} onCheckedChange={() => r.onToggle()}
                w="100%" minH="44px" px={3} borderRadius="md" justifyContent="space-between" cursor="pointer"
                bg="surface" borderWidth="1px" borderColor="border">
                <Switch.HiddenInput />
                <Switch.Label color={r.on ? 'fg' : 'fg.muted'}>{r.label}</Switch.Label>
                <Switch.Control><Switch.Thumb /></Switch.Control>
              </Switch.Root>
            ))}
          </VStack>
        ))}
      </VStack>
    </Box>
  )
}
